import { useQuery } from "@tanstack/react-query";

import { listStages } from "@/adapters/api";
import {
	toConstructionSummary,
	toStage,
	toStagesLock,
	toStageTotals,
} from "../utils/map.ts";
import { stageKeys } from "../utils/query-keys.ts";

export function useStages(constructionId: string | undefined) {
	return useQuery({
		queryKey: stageKeys.list(constructionId),
		queryFn: async () => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			const response = await listStages(constructionId!);
			return {
				stages: response.items.map(toStage),
				construction: toConstructionSummary(response.construction),
				lock: toStagesLock(response.lock),
				totals: toStageTotals(response.totals),
			};
		},
		enabled: !!constructionId,
		staleTime: 30_000,
	});
}
